import { RECEIVE_DATA } from 'Config/types';
import util from 'Utils';

const { mapKV } = util.obj;

/**
 * Should transform the ajax table data into the table state
 * @param  {object} state  previous state
 * @param  {object} action current action
 * @return {object}        new state
 */
// @TODO lets make this monothlic function smaller
export default function tableTransformer(state, action) {
  if (RECEIVE_DATA === action.type) {
    const { data, indicators } = state.data;
    const indicatorMap = getIndicatorsByGDocsKey(indicators);
    const mappedData = data.map((x) => ({ ...x, id: indicatorMap[x.key] }));
    return { ...state, table: { ...state.table, indicators: mappedData } };
  }
  return state;
}

/**
 * Get the dataviews from the data set
 * the first item of a row has all the info we Need
 * @param  {array} data  to retreive dataViews
 * @return {array}       array of dataViews
 */
export function getDataViews(data) {
  return data.find(({ dataViews }) => dataViews).dataViews;
}

/**
 * Get the indicators by gdoc key
 * @param  {array}  indicators indicators to swap
 * @return {object}            dictionary of lookups
 */
export function getIndicatorsByGDocsKey(indicators) {
  return mapKV(
    indicators,
    ({ gdocs_key: gdoc }, key) => ({ [gdoc]: key }),
    true
  ).reduce((acc, item) => ({ ...acc, ...item }), {});
}



// WEBPACK FOOTER //
// ./app/reducers/tableTransformer.js